export default {
    en: 'En',
    he: 'עב',
    ar: 'عر',
    ru: 'Ру'
};
